<template>
  <vs-table hover-flat v-if="cdrDatas && cdrDatas.length" :data="cdrDatas">
    <template slot="thead">
      <vs-th v-text="$t('no')"></vs-th>
      <vs-th v-text="$t('called_number')" v-if="activeColumns.includes('called_number')"></vs-th>
      <vs-th v-text="$t('member_name')" v-if="activeColumns.includes('member_name')"></vs-th>
      <vs-th v-text="$t('date')" v-if="activeColumns.includes('date')"></vs-th>
      <vs-th v-text="$t('time')" v-if="activeColumns.includes('time')"></vs-th>
      <vs-th v-text="$t('call_time')" v-if="activeColumns.includes('call_time')"></vs-th>
      <vs-th v-text="$t('outgoing_counselor')" v-if="activeColumns.includes('outgoing_counselor')"></vs-th>
      <vs-th v-text="$t('disposition')" v-if="activeColumns.includes('disposition')"></vs-th>
      <vs-th class="text-center" v-text="$t('one_touch_record')" v-if="activeColumns.includes('one_touch_record')"></vs-th>
      <vs-th class="text-center" v-text="$t('record_file')" v-if="activeColumns.includes('record_file')"></vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :key="key" v-for="(tr, key) in data">
        <vs-td v-text="tr.count" :data-tr-title="$t('no')"></vs-td>
        <vs-td v-if="activeColumns.includes('called_number')" v-text="tr.dst" :data-tr-title="$t('called_number')"></vs-td>
        <vs-td v-if="activeColumns.includes('member_name')" :data-tr-title="$t('member_name')">
          <div class="d-inline-block" v-if="tr.member">
            <span v-if="tr.member && tr.member.name && tr.member.name.length > 0" v-text="tr.member.name"></span>
            <span v-else>--</span>
          </div>
          <div class="d-inline-block" v-else>
            <span>--</span>
          </div>
        </vs-td>
        <vs-td v-if="activeColumns.includes('date')" v-text="tr.date" :data-tr-title="$t('date')"></vs-td>
        <vs-td v-if="activeColumns.includes('time')" v-text="tr.time" :data-tr-title="$t('time')"></vs-td>
        <vs-td v-if="activeColumns.includes('call_time')" v-text="tr.duration" :data-tr-title="$t('call_time')"></vs-td>
        <vs-td v-if="activeColumns.includes('outgoing_counselor')" v-text="tr.outgoingCounselor" :data-tr-title="$t('outgoing_counselor')"></vs-td>
        <vs-td v-if="activeColumns.includes('disposition')" v-text="$t(tr.disposition)" :data-tr-title="$t('disposition')"></vs-td>
        <vs-td v-if="activeColumns.includes('one_touch_record')" :data-tr-title="$t('one_touch_record')">
          <div class="flex justify-center" v-if="!hasRecording(tr)" />
          <div class="flex justify-center gap-2" v-else>
            <vx-tooltip :text="$t('play')" position="bottom">
              <vs-button color="primary" type="border" icon-pack="feather" icon="icon-play" size="small" @click.prevent="playOneTouchRecording(tr.dst, tr.uniqueid)"></vs-button>
            </vx-tooltip>
            <vx-tooltip :text="$t('download')" position="bottom">
              <vs-button color="primary" type="border" icon-pack="feather" icon="icon-download" size="small" @click.prevent="downloadOneTouchRecording(tr.dst, tr.uniqueid)"></vs-button>
            </vx-tooltip>
          </div>
        </vs-td>
        <vs-td v-if="activeColumns.includes('record_file')" :data-tr-title="$t('record_file')">
          <div class="flex justify-center" v-text="$t('no_transcript_file')" v-if="!hasRecording(tr)" />
          <div class="flex justify-center gap-2" v-else>
            <vx-tooltip :text="$t('play')" position="bottom">
              <vs-button color="primary" type="border" icon-pack="feather" icon="icon-play" size="small" @click.prevent="playRecording(tr.dst, tr.uniqueid)"></vs-button>
            </vx-tooltip>

            <vs-dropdown vs-trigger-click class="cursor-pointer" v-if="$store.getters.hasCompanyPermission('company_can_download_split_recording')">
              <vs-button color="primary" type="border" icon-pack="feather" icon="icon-download" size="small"></vs-button>
              <vs-dropdown-menu>
                <vs-dropdown-item @click="downloadRecording(tr.dst, tr.uniqueid, 'all')">{{ $t('recording_part_all') }}</vs-dropdown-item>
                <vs-dropdown-item @click="downloadRecording(tr.dst, tr.uniqueid, 'mix')">{{ $t('recording_part_mixed') }}</vs-dropdown-item>
                <vs-dropdown-item @click="downloadRecording(tr.dst, tr.uniqueid, 'out')">{{ $t('recording_part_customer') }}</vs-dropdown-item>
                <vs-dropdown-item @click="downloadRecording(tr.dst, tr.uniqueid, 'in')">{{ $t('recording_part_agent') }}</vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
            <vx-tooltip :text="$t('download')" position="bottom" v-else>
              <vs-button color="primary" type="border" icon-pack="feather" icon="icon-download" size="small" @click.prevent="downloadRecording(tr.dst, tr.uniqueid)"></vs-button>
            </vx-tooltip>

            <vx-tooltip :text="$t('call_note')" position="bottom" v-if="$store.getters.hasCompanyPermission('company_can_use_callnote') && parseInt(tr.duration) >= 60">
              <vs-button color="primary" type="border" icon-pack="feather" icon="icon-clipboard" size="small" @click.prevent="callNoteConvert({ dst: tr.dst, uniqueId: tr.uniqueid })"></vs-button>
            </vx-tooltip>
          </div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
  <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
    <div v-text="$t('no_record')"></div>
  </vs-alert>
</template>

<script>
import ctiWindow from '@/helpers/ctiWindow'
import Consultation from '@/models/Consultation'
import Cti from '@/models/Cti'

export default {
  name: 'Shared.OutboundDetails.List',
  props: {
    cdrDatas: {
      type: [Object, Array],
      required: true
    },
    activeColumns: {
      type: [Object, Array],
      required: true
    }
  },
  methods: {
    /**
     * A recording is offered when the file actually exists, not when the call
     * was answered. Asterisk writes `cdr.recordingfile` when MixMonitor starts,
     * which happens before answer, so a NO ANSWER call can still have audio.
     *
     * `has_recording` comes from the API. The `cdr.recordingfile` fallback keeps
     * this working if the SPA is deployed ahead of the API.
     */
    hasRecording (tr) {
      if (typeof tr.has_recording !== 'undefined' && tr.has_recording !== null) {
        return Boolean(tr.has_recording)
      }
      return Boolean(tr.cdr && tr.cdr.recordingfile)
    },
    playRecording (dst, uniqueId) {
      ctiWindow.consultationRecordingFile(dst, uniqueId, 'outbound')
    },
    /**
     * 발신 통화는 내선 채널에 녹취가 걸리므로 분리본의 -in 이 상담원, -out 이 고객이다.
     * 수신과 반대이므로 메뉴 라벨과 part 의 짝이 인바운드 상세와 뒤바뀐다.
     * 분리 적용 이전 통화에는 합본만 있어서, 없는 파트는 API 가 404 로 알려준다.
     */
    async downloadRecording (dst, uniqueId, part = 'mix') {
      try {
        await Consultation.downloadRecording({dst, uniqueId, companyId: this.$store.getters.userInfo.company.id, type: 'outbound', part})
      } catch (e) {
        this.$alertHelper.error()
      }
    },
    playOneTouchRecording (dst, uniqueId) {
      ctiWindow.consultationOneTouchRecordingFile(dst, uniqueId, 'outbound')
    },
    async downloadOneTouchRecording (dst, uniqueId) {
      try {
        await Consultation.downloadOneTouchRecording({dst, uniqueId, companyId: this.$store.getters.userInfo.company.id, type: 'outbound'})
      } catch (e) {
        this.$alertHelper.error()
      }
    },
    async callNoteConvert ({ dst, uniqueId }) {
      const response = await Cti.showRecordingFile({
        unique_id: uniqueId,
        dst
      })
      ctiWindow.openCallNoteWindow(response.data.path)
    }
  }
}
</script>

<style scoped>

</style>
